<template>
  <el-container>
    <!-- 头部部分 -->
    <el-header v-if="query_mode != 'inshop'" style="z-index: 9999">
      <Header @backHome="backHome" :userInfo="userInfo"></Header>
    </el-header>
    <el-main class="pageWidth pages">
      <!-- 搜索Vin码view -->
      <SearchVinMa
        ref="searchView"
        @queryVinEvent="queryVin"
        @technologyEvent="technologyEvent"
        @parseTextEvent="parseText"
        @logsItemClick="logsItemClick"
        :userInfo="userInfo"
        :IsVip="IsVip"
      ></SearchVinMa>
      <!-- 技术参数弹层部分 -->
      <div class="hbb_technology" v-show="technologyState">
        <TechnologyModal
          ref="technologyview"
          v-if="technologyState"
          @closeEvent="technologyState = false"
        ></TechnologyModal>
      </div>
      <!-- 首次加载出现 -->
      <div class="hbb_indexPage" v-show="isFristIn">
        <FirstStep
          ref="homeView"
          @modeOpen="modeOpen"
          @DistinguishSuccess="on_FirstStep_DistinguishSuccess"
          @DistinguishFail="on_FirstStep_DistinguishFail"
        ></FirstStep>
      </div>

      <div class="hbb_brandView_wrapper" v-show="!isFristIn">
        <!-- brankTop 部分 -->
        <BrandTop
          class="hbb_brandView"
          ref="brandView"
          @brandOneClick="brandOneClick"
          @delOneClick="delOneClick"
        ></BrandTop>
        <div class="sdw_copy_tips_container">
          <div class="sdw_copy_tips">双击编码即可复制</div>
        </div>
        <div class="hbb-brankConent">
          <div class="hbb_BrankBorder">
            <!-- brankLeft 部分 -->
            <!-- <el-col :span="4">
              <BrankSidebar></BrankSidebar>
            </el-col>-->
            <el-col :span="24">
              <BrankProduct
                ref="productView"
                @GetCjmlAutoValidPartSuccess="GetCjmlAutoValidPartSuccess"
                @lastOverEvent="lastOverEvent"
              ></BrankProduct>
            </el-col>
          </div>
        </div>
      </div>
    </el-main>
    <!-- 识别弹框 -->
    <Modal :text="modalText" v-if="distinguishModal"></Modal>
    <!-- 滑块验证 -->
    <el-dialog
      title="提示"
      :visible.sync="isVerify"
      width="30%"
      center
      class="sdw-sliderverification-dialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <DragView
        v-if="isVerify"
        @verifydata="verifyCheck"
        v-show="isVerify"
      ></DragView>
    </el-dialog>

    <!-- 隐藏的footer -->
    <el-footer style="height: 0px"> </el-footer>
  </el-container>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import Header from "@components/header/Index";
import Modal from "@components/Modal/Index";
import TechnologyModal from "@components/TechnologyModal/Index";
import DragView from "@components/DragView/index";
import payment from "@components/payment/payment";
import SearchVinMa from "./InnerComponent/SearchVinMa";
import FirstStep from "./InnerComponent/FirstStep";
import BrandTop from "./InnerComponent/BrandTop";
import BrankSidebar from "./InnerComponent/BrankSidebar";
import BrankProduct from "./InnerComponent/BrankProduct";
import server from "@/utils/server";
export default {
  components: {
    Header,
    SearchVinMa,
    BrandTop,
    BrankSidebar,
    BrankProduct,
    FirstStep,
    Modal,
    TechnologyModal,
    DragView,
    payment,
  },
  data() {
    return {
      apiDomian: process.env.VUE_APP_API_DOMAIN, // 不同环境走不同的地址 [仅供上传]
      isFristIn: true, // 初始化
      vincodeQuery: this.$route.query.v || "", // 查询vin码 用于管控页面的前进后退
      requestCategory: {}, // 轮询q请求第几个品类的id
      timer: null, // 轮询
      allObj: {}, // 存放初始的所有数据
      distinguishModal: false, // 正在识别中的弹框
      modalText: "VIN码识别中...",
      technologyState: false, // 技术参数弹层是否启动
      isVerify: false, // 滑块验证
      verifyData: {}, // verifyData 只是用于在验证成功做的桥梁
      query_mode: this.$route.query.mode || "standalone", // 启动模式 inshop: 代表门店启动的嵌入模式
      destroy: false,
      VvipCount: 0, //免费查询次数
      IsVip: true, //是否VIP
      userInfo: {}, //用户信息
      isShowExpireHint: true, //是否展示到期服务
      PartListClick: [],
    };
  },
  watch: {
    $route: {
      handler: function (val, oldVal) {
        console.log(val);
      },
      // 深度观察监听
      deep: true,
    },
  },
  computed: {
    ...mapGetters({
      carNumber: "CommonModule/getcarNumber",
      isCreated: "CommonModule/getViewModalOver",
    }),
  },
  created() {
    server.myAxios("/api/UserCenter/GetUser").then((res) => {
      this.userInfo = res;

      //手机尾号为1的展示到期提示
      // if (this.userInfo.mobile) {
      //   var last_char = this.userInfo.mobile.substring(
      //     this.userInfo.mobile.length - 1
      //   );
      //   this.isShowExpireHint = last_char == "1";
      // }
    });
  },

  mounted() {
    let _this = this;
    // _this.getVinShareStatistics();
    _this.getIsVIP();
    _this.$nextTick(() => {
      _this.init();
    });
  },
  methods: {
    ...mapMutations({
      setViewModalOver: "CommonModule/SET_VIEWMODALOVER",
    }),
    init() {
      if (this.isFristIn) {
        this.destroy = true;
        setTimeout(() => {
          let h = $(".hbb_indexPage").offset().top;
          let wh = $(document).height();
          let dh = wh - h - 20;
          $(".hbb_indexPage").css({ height: dh + "px" });
        }, 0);
      }
    },
    queryVin(key) {
      this.isFristIn = true;
      setTimeout(() => {
        this.requestCategory = this.$refs.productView.validCategorys[0];
        this.$refs.homeView.DistinguishFn(key, 1);
        this.technologyState = false;
      }, 0);
    },
    // getVinShareStatistics() {
    //   server.myAxios("/api/UserCenter/GetVinShareStatistics").then((res) => {
    //     this.VvipCount = res.VvipCount;
    //   });
    // },
    getIsVIP() {
      server.myAxios("/api/UserCenter/GetIsVip").then((res) => {
        this.IsVip = res;
        console.log(1, res);
      });
    },
    brandOneClick(brandId) {
      // 点击品牌关联该品牌所对应的的商品
      let datalist = JSON.parse(
        JSON.stringify(this.$refs.productView.validCategorys)
      );
      let isChange = false;
      datalist.forEach((x) => {
        x.categroys.forEach((y) => {
          if (y.oemDosageList) {
            y.oemDosageList.forEach((z) => {
              z.partItems
                .filter((a) => {
                  return a.brandId == brandId;
                })
                .forEach((j) => {
                  j.isSelect = !j.isSelect;
                  isChange = j.isSelect;
                });
            });
          }
        });
      });
      this.$refs.productView.validCategorys = datalist;
      if (isChange) {
        isChange = true;
      } else {
        isChange = false;
      }
      this.$refs.productView.productPosition(brandId, isChange);
    },
    on_FirstStep_DistinguishSuccess(res, verifyData) {
      console.log(`on_FirstStep_DistinguishSuccess res`, res);
      console.log(`on_FirstStep_DistinguishSuccess verifyData`, verifyData);
      this.$refs.productView.clearCurrentBrands();
      // 识别成功 填充到搜索哪边的div
      let _this = this;
      let {
        auto_text,
        autoInfo,
        autoParamGroups,
        jYAutoByVin,
        validBrands,
        validCategorys,
        vinCode,
        isNeedNext,
        isShowSliderVerification,
      } = res;
      setTimeout(() => {
        if (this.isFristIn) {
          this.distinguishModal = false;
          this.$refs.homeView.distinguishModal = true;
        } else {
          if (!isShowSliderVerification) {
            this.distinguishModal = true;
          } else {
            this.distinguishModal = false;
          }
          this.$refs.homeView.distinguishModal = false;
        }
        // if (type !== 1) {
        //   _this.$refs.searchView.vinImgSrc = _this.$refs.homeView.showSuccessImg;
        // } else {
        //   _this.$refs.searchView.vinImgSrc = "";
        // }
        _this.$refs.searchView.auto_text = auto_text;
        _this.$refs.searchView.autoInfo = autoInfo;
        _this.$refs.searchView.jYAutoByVin = jYAutoByVin;
        _this.$refs.searchView.autoParamGroups = autoParamGroups;
        _this.$refs.searchView.searchVinKey = vinCode;
        _this.$refs.brandView.validBrands = validBrands;
        if (isShowSliderVerification) {
          _this.isVerify = true;
          _this.verifyData = verifyData;
          return false;
        }
        if (!isNeedNext) {
          _this.$message({
            type: "warning",
            message: res.message,
          });
          _this.distinguishModal = false;
          this.$refs.homeView.distinguishModal = false;
          this.setViewModalOver(true);
          return false;
        }
        _this.$refs.productView.validCategorys = validCategorys;
        _this.$refs.productView.vinCode = vinCode;
        _this.requestCategory = _this.$refs.productView.validCategorys[0];

        setTimeout(() => {
          if (_this.requestCategory.categroys.length > 0) {
            _this.$refs.productView.GetCjmlAutoValid(_this.requestCategory, 0);
            _this.$refs.productView.scrollTopFn();
          }
        }, 0);
      }, 0);
    },
    GetCjmlAutoValidPartSuccess(c, index) {
      // 按顺序去请求所有品类组所对应的商品 c 代表找到的下一个对象
      // 如果请求成功一次我就把默认把查询按钮设为可点击的状态
      this.$refs.searchView.canSubmitVin = false;
      this.requestCategory = c;
      this.$refs.productView.GetCjmlAutoValid(this.requestCategory, index);
    },

    // dom已经全部渲染成功
    lastOverEvent() {
      this.isFristIn = false;
      this.distinguishModal = false;
      this.setViewModalOver(true);
      // 获取组件有效品牌配件
      this.$refs.brandView.setPartListClick(
        this.$refs.productView.getCurrentBrands()
      );

      // 重置有效品类
      this.$refs.brandView.resetBrandEnable(
        this.$refs.productView.getCurrentBrands()
      );
      this.getIsVIP();
    },
    on_FirstStep_DistinguishFail(err) {
      // 识别失败 填充到搜索哪边的div
      this.isFristIn = true;
      this.distinguishModal = false;
    },
    modeOpen(type) {
      if (type == 2) {
        this.modalText = "VIN码识别中...";
      } else {
        this.modalText = "VIN码识别中...";
      }
      if (!this.isFristIn) {
        this.distinguishModal = true;
      } else {
        this.distinguishModal = false;
      }
    },
    logsItemClick(item, type) {
      // 点击历史vin码记录进行筛选 type 代表从扫码记录点进来的 carNumber： 1表示第一次点击
      let _this = this;

      if (this.carNumber == 1) {
        this.setViewModalOver(true);
      }
      if (!this.isCreated) {
        this.$message({
          type: "info",
          message: "当前列表数据未加载完，为了您的操作流畅性，请稍后重试",
        });

        return false;
      }
      this.setViewModalOver(false);
      _this.technologyState = false;
      _this.requestCategory = {};
      // if (type) {
      //   _this.distinguishModal = true;
      // }
      _this.requestCategory = this.$refs.productView.validCategorys[0];
      setTimeout(() => {
        _this.$refs.searchView.searchVinKey = item.vinCode;
        _this.$refs.homeView.DistinguishFn(item.vinCode, 1, type);
        _this.$refs.productView.scrollTopFn();
      }, 0);
    },
    parseText() {
      // 点击黏贴复制的事件
      // 去首页
      this.$router.push({
        path: "/",
        query: { mode: this.query_mode },
      });
      setTimeout(() => {
        location.reload();
      }, 0);
      setTimeout(() => {
        location.reload();
      }, 0);
      // this.requestCategory = this.$refs.productView.validCategorys[0];
      // this.technologyState = false;
      // this.$refs.homeView.showSuccessImg = "";
      // if (this.carNumber > 1) {
      //   this.isFristIn = !this.isFristIn;
      // }
    },
    technologyEvent() {
      let _this = this;
      _this.technologyState = !_this.technologyState;
      setTimeout(() => {
        let divOffsetTop = $(".hbb_brandView").offset().top;
        let windowHeight = $(window).height();
        let divHeight = windowHeight - divOffsetTop;
        $(".hbb_technology").css({
          height: divHeight + "px",
          // marginTop: -20 + "px",
        });
      }, 0);
      if (_this.technologyState) {
        _this.$nextTick(() => {
          // _this.$refs.technologyview.active(_this.$refs.searchView.jYAutoByVin, _this.$refs.productView.vinCode);
          _this.$refs.technologyview.active(
            _this.$refs.searchView.autoParamGroups,
            _this.$refs.productView.vinCode
          );
        });
      }
    },
    verifyCheck(data) {
      // 滑块验证成功
      this.isVerify = data;
      this.$refs.homeView.DistinguishFn(
        this.verifyData.resSrc,
        this.verifyData.type,
        this.verifyData.isRecod
      );
    },
    backHome() {
      // 返回首页
      this.isFristIn = true;
      this.$refs.homeView.distinguishModal = false;
    },
  },
};
</script>

<style>
.el-header {
  background: #fff;
  height: 50px !important;
}
.hbb-brankConent {
  background: #fff;
  display: flex;
  width: 100%;
  padding: 0 0 20px 20px;
}
.hbb_BrankBorder {
  display: flex;
  width: 100%;
  border-top: 2px solid #e5e5e5;
  overflow: hidden;
}
.hbb_indexPage {
  min-height: 300px;
  background: #fff;
  margin-top: -50px;
  z-index: 9;
  position: relative;
  box-shadow: 0 0 -10px 20px rgba(231, 76, 60, 0.52);
  border-radius: 4px;
  border: 2px solid rgba(226, 149, 141, 0.52);
}
/* 技术参数弹层内容 */
.hbb_technology {
  display: block;
  width: 1200px;
  position: fixed;
  left: 50%;
  margin-left: -600px;
  z-index: 999;
  padding: 20px;
  background: #fff;
  border: 2px solid rgba(226, 149, 141, 0.52);
  overflow: hidden;
  overflow-y: auto;
}
.sdw_copy_tips_container {
  width: auto;
  height: auto;
  background: none;
  margin-bottom: -31px;
  position: relative;
  right: 21px;
  z-index: 3;
  float: right;
  clear: right;
}
.sdw_copy_tips_container .sdw_copy_tips {
  width: 100%;
  border: 1px solid #d8d8d8;
  background: #f8f8f8;
  border-radius: 0 0 3px 3px;
  padding: 0 8px;
  font-size: 13px;
  line-height: 28px;
  text-align: center;
  color: #e74c3c;
}
.hbb_brandView_wrapper {
  margin-top: 10px;
}
</style>